module.exports = __webpack_public_path__ + "static/media/insta-2.e0240b0b.png";